import Vue from 'vue'
import { formatDateFilter, formatDateWithTimeFilter } from './date'
import { MoneyFilter } from './money'
import { AbreviacaoFilter, formatCPFFilter } from './geral'

// TODO: Buscar por todas as ocorrencias e deixar somente o currency
Vue.filter('money', MoneyFilter)
Vue.filter('currency', MoneyFilter)

Vue.filter('formatDate', formatDateFilter)
Vue.filter('formatDateWithTime', formatDateWithTimeFilter)

Vue.filter('formatCPF', formatCPFFilter)

Vue.filter('nameNormalize', AbreviacaoFilter)

export * from './money'
export * from './date'
export * from './geral'
export * from './phone'
